const getClientId = () => window.EMP?.MSAL_CLIENT_ID;
const getTenantId = () => window.EMP?.MSAL_TENANT_ID;
const getBackendAppId = () => window.EMP?.MSAL_BACKEND_APP || null;
const getBackendScopeName = () => window.EMP?.MSAL_BACKEND_SCOPE || "emp-ui";

export const msalConfig = {
  auth: {
    clientId: getClientId(),
    authority: `https://login.microsoftonline.com/${getTenantId()}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
};

// Throw rather than silently falling back to Microsoft Graph's `User.Read`
// scope. Without the backend app id we'd request a Graph access token,
// which is rejected by Spring's JWT decoder with the unhelpful "Malformed
// token" error. Failing loudly here makes the misconfiguration obvious.
export const getBackendScopes = () => {
  const appId = getBackendAppId();
  if (!appId) {
    throw new Error(
      "MSAL_BACKEND_APP is not configured in window.EMP. " +
        "Set window.EMP.MSAL_BACKEND_APP to the Azure AD application ID of the backend service."
    );
  }
  return [`api://${appId}/${getBackendScopeName()}`];
};
